import {useEffect, useState} from 'react';
import {Link, useNavigate} from "react-router-dom";
import {UseDelete, UsePut} from "../../hooks/http";
import {UseLimit, UseOrder} from "../../hooks/settings";
import {UseMessage} from "../../hooks/UseMessage";

import ListingTable from "../../components/listing/listing";
import {UtcDateTimeToDateTime} from "../../hooks/dates";
import CardMenu from "../../components/card-menu";
import Menu from "./TopMenu";
import Button from "../../components/button";


const Segments = ({audience}) => {
    const navigate = useNavigate()
    const searchColumn = 'name'
    const [isLoading, setIsLoading] = useState(true)
    const [entities, setEntities] = useState([])
    const [totalEntities, setTotalEntities] = useState(0)
    const [currentOffset, setCurrentOffset] = useState(0)
    const [currentLimit, setCurrentLimit] = useState(UseLimit)
    const [currentOrder, setCurrentOrder] = useState(UseOrder)
    const [searchValue, setSearchValue] = useState("")
    const [bulkAction, setBulkAction] = useState()
    const [lastChange, setLastChange] = useState(Date.now())
    const AudienceMenu = Menu({audience: audience})


    const fetchEntities = async () => {
        let filters = {
            limit    : currentLimit,
            offset   : currentOffset,
            sortBy   : "created_at",
            sortOrder: currentOrder,
        };

        if (searchValue.trim() !== "") {
            filters["findBy"] = searchColumn;
            filters["findTerm"] = searchValue;
        }

        const request = await UsePut(`/audiences/${audience?._id?.$oid}/segments/get`,
            {data: filters}
        );

        setTotalEntities(request.total);
        return request?.entities?.length > 0 ?
            request.entities : [];
    };


    useEffect(() => {
        fetchEntities().then((entities) => {
            setEntities(entities);
            setIsLoading(false);
        });
    }, [currentOffset, currentLimit, searchValue, currentOrder, lastChange]);


    const handleDelete = async (selected) => {
        if (selected.length === 0) {
            UseMessage("error", "Please choose some items")
        } else {

            UseDelete(`/audiences/${audience?._id?.$oid}/segments/delete`,
                {
                    data: {idx: selected}, onSuccess: (response) => {
                        setLastChange(Date.now());
                    }
                }
            ).then((response) => {
                if(response?.response?.data?.code < 200 || response?.response?.data?.code > 299){
                    UseMessage('error', response.response.data.message)
                }
            }).catch((error) => {
                if(error?.response?.data?.code < 200 || error?.response?.data?.code > 299){
                    UseMessage('error', error.response.data.message)
                }
            })
        }
    };


    const  addNewSegment = () => {
        navigate(`/audiences/${audience?._id?.$oid}/segments/create`)
    }


    const ListingOptions = {
        entities      : entities,
        isLoading     : isLoading,
        currentPage   : Math.ceil(currentOffset / currentLimit) + 1,
        totalEntities : totalEntities,
        currentLimit  : currentLimit,
        currentOrder  : currentOrder,
        searchColumn  : searchColumn,
        template      : "table",
        onSearch      : (value) => {
            setCurrentOffset(0);
            setSearchValue(value);
        },
        onCleanSearch : () => {
            setSearchValue("");
        },
        onChangePage  : (page) => {
            setCurrentOffset(currentLimit * (page - 1));
        },
        onChangeLimit : (ev) => {
            UseLimit(setCurrentLimit, ev.target.text);
        },
        onChangeOrder : (ev) => {
            UseOrder(setCurrentOrder, ev.target.text);
        },
        onChangeAction: (action) => {
            setBulkAction(action);
        },
        onClickApply  : (selected) => {
            if (typeof bulkAction == "undefined") {
                UseMessage("error", "Please choose an action")
            } else {
                bulkAction["action"](selected);
            }
        },
        columns       : [
            {
                label: "Name", prop: "name", size: 25, output: (entity) => {
                    return <Link to={`/audiences/${audience?._id?.$oid}/segments/${entity?._id?.$oid}`}>
                        <strong>{entity?.name}</strong>
                    </Link>;
                }
            },
            {label: "Rules", prop: "fields", output: (entity) => {
                    return 8
                }
            },
            {label: "Limit", prop: "segments", output: (entity) => {
                    return 10
                }
            },
            {label: "Ws", size: 25, prop: "enterprise", output: (entity) => {
                    return entity?.use_ws_limit ? "Yes" : "No"
                }
            },
            {
                label: "Created at", size: 15, prop: "created_at", output: (entity) => {
                    return UtcDateTimeToDateTime(entity?.created_at);
                }
            }
        ],
        filters       : [],
        actions       : [
            {value: "delete", label: "Delete", action: (selected) => handleDelete(selected)}
        ],
        edit          : {
            path : `/audiences/:id`,
            label: "Edit audience",
            icon : "edit"
        },
        addons        : {
            afterCard: <CardMenu {...AudienceMenu}/>,
            top      : {
                left:
                    <div className="d-flex">
                        <div className="me-2">
                            <Button
                                size="sm"
                                icon="plus"
                                color="primary"
                                isReady={!isLoading}
                                onClick={addNewSegment}
                                style={{height: '32px'}}
                            />
                        </div>
                    </div>
            }
        }
    };


    return (
        <>
            <ListingTable {...ListingOptions} />
        </>
    )
}

export default Segments;